import { listaEstadosActivo } from "../../../app/constants/constants-selectores";

interface CompaniaFormCamposProps {
    register: any;
    errors: any;
    accion?: string;
}

export const CompaniaFormCampos = ({ register, errors, accion }: CompaniaFormCamposProps) => {
    return (
        <>
            {/*
                                <div className="col-12 col-lg-6">
                                    <div className="d-flex align-items-center">
                                        <label className="col-4 text-start px-2">Compañía principal</label>
                                        <select {...register("CompPrinc")} className="form-select form-select-sm" >
                                            {
                                                listaEstados?.length > 0 && listaEstados.map(e => (
                                                    <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div> */}

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Código</label>
                    <input
                        {...register("CompCod", {
                            required: {
                                value: true,
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        readOnly={accion === "editar" ? true : false}
                    />
                </div>
                {errors.CompCod && errors.CompCod.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese código</p>}
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Prefijo</label>
                    <input
                        {...register("CompPre")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">RUC</label>
                    <input
                        {...register("CompRuc", {
                            required: {
                                value: true,
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
                {errors.CompRuc && errors.CompRuc.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese RUC</p>}
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Razon Social</label>
                    <input
                        {...register("CompRSoc", {
                            required: {
                                value: true,
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
                {errors.CompRSoc && errors.CompRSoc.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese Razon Social</p>}
            </div>
            <div className="col-12 col-lg-12">
                <div className="d-flex align-items-center">
                    <label className="col-4 col-lg-2 text-start px-2">Nombre</label>
                    <input
                        {...register("CompNom", {
                            required: {
                                value: true,
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
                {errors.CompNom && errors.CompNom.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese nombre</p>}

            </div>
            <div className="col-12 col-lg-12">
                <div className="d-flex align-items-center">
                    <label className="col-4 col-lg-2 text-start px-2">Dirección</label>
                    <input
                        {...register("CompDirec", {
                            required: {
                                value: true,
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
                {errors.CompDirec && errors.CompDirec.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese dirección</p>}
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Correo</label>
                    <input
                        {...register("CompCor")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Telefono</label>
                    <input
                        {...register("CompTel")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Estado</label>
                    <select {...register("CompEst")} className="form-select form-select-sm" >
                        {
                            listaEstadosActivo?.length > 0 && listaEstadosActivo.map(e => (
                                <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                            ))
                        }
                    </select>
                </div>
            </div>

            {/* <div className="col-12 col-lg-6">
                                    <div className="d-flex align-items-center">
                                        <label className="col-4 text-start px-2">App Default</label>
                                        <select
                                            {...register("CompApDef")}
                                            className="form-select form-select-sm"
                                            value={watch("CompApDef")}
                                        >
                                            <option value={"N"}>NINGUNO</option>
                                            {
                                                listaModulos?.length > 0 && listaModulos.map(a => (
                                                    <option key={a?.ModCod} value={a?.ModCod}>{a?.ModDesc}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div> */}
        </>
    );
};
